// extracted by mini-css-extract-plugin
export default {"mockStepper":"mockStepper_mockStepper__-D0uZ","mockStepper__module":"mockStepper_mockStepper__module__jJ0gV"};